// context/combinedContext.jsx
import { createContext, useState, useEffect } from "react";
import { getInitialLanguage } from "./allStates/initialLanguage";

export const CombinedContext = createContext();

export const CombinedContextProvider = ({ children, initialUserData }) => {
	const [selectedService, setSelectedService] = useState(null);
	const [selectedstaff, setSelectedstaff] = useState(null);
	const [userData, setUserData] = useState(initialUserData || null);
	const [language, setLanguage] = useState(getInitialLanguage());
	const [category, setCategory] = useState(null);
	const [shopsData, setShopsData] = useState(null);

	useEffect(() => {
		if (language) {
			localStorage.setItem("lang", language);
		}
	}, [language]);

	return (
		<CombinedContext.Provider
			value={{
				selectedService,
				setSelectedService,
				selectedstaff,
				setSelectedstaff,
				userData,
				setUserData,
				language,
				setLanguage,
				category, 
				setCategory,
				shopsData,
				setShopsData
			}}
		>
			{children}
		</CombinedContext.Provider>
	);
};
